import React from 'react'
import ErrNames from "../ListingMatchErrors";
import {errorClasses, formatPhone, MaybeLink} from "./util";
import PropTypes from 'prop-types'
import * as ListingProps from "./listing-props";
import classnames from 'classnames'

const WithErrClassFactory = (matchErrors) => ({errorType, children, className, ...props}) => {
  return <span
    {...props}
    className={classnames(
      errorClasses(matchErrors)(...(Array.isArray(errorType) ? errorType : [errorType])),
      className
    )

    }>{children}</span>
}

/**
 * Renders the primary identifying attributes of a listing
 *
 * if you would like to display match errors, include the matchErrors array as a prop
 */
export class ListingSummary extends React.Component {

  static propTypes = {
    listing: ListingProps.listingSummary.isRequired,
    matchErrors: PropTypes.arrayOf(PropTypes.string).isRequired
  }

  static defaultProps = {
    matchErrors: []
  }

  render() {

    const {listing, matchErrors, ...props} = this.props

    const WithErrClass = WithErrClassFactory(matchErrors)

    const getMatchErr = errorClasses(matchErrors)

    let phones;
    if(!listing.phoneNumber){
      phones = [];
    } else if(typeof listing.phoneNumber === 'string') {
      phones = [listing.phoneNumber];
    } else {
      phones = listing.phoneNumber;
    }
    const formattedPhones = phones.map(formatPhone);

    return (
      <React.Fragment>
        <div>
          <MaybeLink
            className={getMatchErr(ErrNames.BusNameMatch, ErrNames.PartialBusNameMatch)}
            href={listing.listingURL}>{listing.businessName || 'No Name'}</MaybeLink>
        </div>
        <div>
          <WithErrClass errorType={ErrNames.StreetMatch} >
            {listing.street || 'No Street'}
          </WithErrClass>
          <WithErrClass errorType={ErrNames.SuiteMatch} >
            {listing.suite}
          </WithErrClass>
        </div>
        <div>
          <WithErrClass errorType={ErrNames.CityMatch}>
            {listing.city || 'No City'}
          </WithErrClass>, <WithErrClass errorType={ErrNames.StateMatch} >
          {listing.state || 'No State'}
        </WithErrClass> <WithErrClass errorType={ErrNames.ZipMatch} >
          {listing.postalCode || 'No Postal Code'}
        </WithErrClass>
        </div>
        <hr className="mt-2"/>
        <div>
          {
            !formattedPhones.length ?
              <WithErrClass errorType={ErrNames.PhoneMatch}>No Phone</WithErrClass>
              : formattedPhones.map(phone => {
                return (<WithErrClass key={phone} errorType={ErrNames.PhoneMatch}>{phone}</WithErrClass>)
              })
          }
        </div>
        <div className="listings-clip-url">
            <MaybeLink
              className={getMatchErr(ErrNames.WebsiteMatch)}
              href={listing.website}>
              {listing.website || 'No Website'}
            </MaybeLink>
        </div>

      </React.Fragment>

    )
  }
};